 <template>
  <div id="page-user-list">
    
      <div class="flex flex-wrap items-center">

  
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <div class="vx-row">
            <div class="vx-col w-full">
            </div>
          </div>
          <br>

          <vx-card>

            <div class="export-table">
              <vs-table stripe pagination max-items="20" :data="memberData" search>

                <template slot="header">
                 <h3>ประวัติ Ranking</h3>

                </template>

                <template slot="thead">
              
                  <vs-th >วัน/เวลา</vs-th>
                  <vs-th> VIP</vs-th>
                  <vs-th> จำนวนเงิน </vs-th>
                </template>

                <template slot-scope="{data}">
                 
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <!-- <vs-button radius color="primary" type="flat"   @click="gotomember(data[indextr].member_username)">{{ data[indextr].member_username}}</vs-button> -->
                    <vs-td>{{ data[indextr].trans_time}}</vs-td>
                    <vs-td>{{ data[indextr].trans_level}}</vs-td>
                    <vs-td>{{currency(data[indextr].trans_amount)}}</vs-td>                   
                  </vs-tr>
                  
                </template>

              </vs-table>
            </div>
          </vx-card>

        </div>
      </div>
    
  </div>

</template>
<script>
import vSelect from 'vue-select'
import axios from '../../../axios'
export default {
  components: {
    vSelect
  },
  data () {
    return {
      
      memberData: []
    }
  },
  mounted () {
    axios
      .get(`/member/${  this.$route.params.username}/ranking`)
      .then(response => (this.memberData = response.data))
  },
  methods:{
    currency (amount) {
      //SET NULL OR NaN = 0
      if (!amount || amount === 'NaN') {
        amount = 0
      }
      if (amount >= 0) {
        if (typeof amount === 'number') {
          amount = String(Math.abs(amount))
        }
        return (amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      } else {
        return `-${(amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
      }

    }
  }
}


</script>

<style lang="scss" scooped>
  #page-user-list {
    .user-list-filters {
      .vs__actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-58%);
      }
    }
  }
</style>
